module.exports = __webpack_public_path__ + "img/mile4m-m@2.db8bd1a1.jpg";